<template>
  <div>
    <Titel title="Unsere Experten und Kontakte" />
    <p>Wir haben unsere Idee nicht nur für die Schublade entwickelt, sondern uns war es wichtig, die Meinung von <b>Experten in Forschung, Politik und Gesellschaft</b> zu unserer Idee zu erfahren.</p>
    <p>Deshalb haben wir uns an zahlreiche <b>Politiker der Bundes-, Landes- und Kommunalebene und Vertreter zivilgesellschaftlicher Vereinigungen</b> aus der Region gewandt, um die Umsetzbarkeit unserer Idee auszuloten. Das überwiegend sehr positive Feedback stimmt uns zuversichtlich, dass wir mit diesem Ansatz tatsächlich in der <b>Realität mithelfen</b> können, den Strukturwandel in der Lausitz zu bewältigen.</p>
    <p>Die Übersicht auf dieser Seite stellt einen Auszug der Personen und Institutionen dar, mit denen wir im persönlichen Kontakt standen bzw. stehen oder E-Mail-Verkehr hatten, um uns mit Ihnen über unsere Idee auszutauschen. Wir möchten uns an dieser Stelle bei jedem Einzelnen der hier Aufgeführten für die <b>Unterstützung und das hilfreiche Feedback bedanken</b>.</p>
    <div style="float: left; width: 100%;" v-if="mobileCheck">
      <Experte v-for="Experte in Experten" :key="Experte.Name" :name="Experte.Name" :amt="Experte.Amt" :foto="Experte.Foto" :website="Experte.Website" :websiteText="Experte.WebsiteText" :parteiUnten="Experte.Partei" />
    </div>
    <div style="float: left; width: 49.5%; margin-right: 0.5%;" v-if="!mobileCheck">
      <Experte v-for="Experte in Experten1" :key="Experte.Name" :name="Experte.Name" :amt="Experte.Amt" :foto="Experte.Foto" :website="Experte.Website" :websiteText="Experte.WebsiteText" :parteiRechts="Experte.Partei" />
    </div>
    <div style="float: left; width: 49.5%; margin-left: 0.5%;" v-if="!mobileCheck">
      <Experte v-for="Experte in Experten2" :key="Experte.Name" :name="Experte.Name" :amt="Experte.Amt" :foto="Experte.Foto" :website="Experte.Website" :websiteText="Experte.WebsiteText" :parteiRechts="Experte.Partei" />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import Titel from '@/components/Titel'
import Experte from '@/components/Experte'

export default {
  name: 'Experten',

  components: {
    Titel,
    Experte
  },

  data () {
    return {
      Experten: [
        {
          Name: 'Dr. Felix Rösel',
          Amt: 'Wissenschaftlicher Mitarbeiter ifo Dresden',
          Website: 'https://www.ifo.de/forschung/ifo-dresden',
          WebsiteText: 'www.ifo.de/forschung/ifo-dresden',
          Foto: 'ifo'
        },
        {
          Name: 'Prof. Dr. Joachim Ragnitz',
          Amt: 'Stellvertretender Leiter ifo Dresden',
          Website: 'https://www.ifo.de/forschung/ifo-dresden',
          WebsiteText: 'www.ifo.de/forschung/ifo-dresden',
          Foto: 'ifo'
        },
        {
          Name: 'Prof. Dr. Marcel Thum',
          Amt: 'Leiter ifo Dresden',
          Website: 'https://www.ifo.de/forschung/ifo-dresden',
          WebsiteText: 'www.ifo.de/forschung/ifo-dresden',
          Foto: 'ifo'
        }
      ]
    }
  },

  computed: {
    mobileCheck: function () {
      let check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true
      })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    },

    Experten1: function () {
      var R = []
      for (var Experte in this.Experten) {
        if (this.Experten[Experte].Position % 2 === 1) {
          R.push(this.Experten[Experte])
        }
      }
      return R
    },

    Experten2: function () {
      var R = []
      for (var Experte in this.Experten) {
        if (this.Experten[Experte].Position % 2 === 0) {
          R.push(this.Experten[Experte])
        }
      }
      return R
    }
  },

  mounted: function () {
    firebase.database().ref('Experten').on('value', snap => {
      this.Experten = []
      for (var Experte in snap.toJSON()) {
        if (!snap.child(Experte + '/anzeigen').exists() || snap.child(Experte + '/anzeigen').val() === true) {
          this.Experten.push({
            Name: snap.child(Experte + '/Name').val(),
            Amt: snap.child(Experte + '/Amt').val(),
            Website: snap.child(Experte + '/Website').val(),
            WebsiteText: snap.child(Experte + '/WebsiteText').val(),
            Foto: snap.child(Experte + '/Foto').val(),
            Position: snap.child(Experte + '/Position').val(),
            Partei: snap.child(Experte + '/Partei').val()
          })
        }
      }
      this.Experten.sort(function (Experte1, Experte2) {
        if (Experte1.Position < Experte2.Position) return -1
        if (Experte1.Position > Experte2.Position) return 1
        return 0
      })
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Experten.vue